"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datasetPropertyLabels = exports.DatasetPropertyType = void 0;

var _datasetPropertyLabel;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatasetPropertyType;
exports.DatasetPropertyType = DatasetPropertyType;

(function (DatasetPropertyType) {
  DatasetPropertyType["BOOLEAN"] = "boolean";
  DatasetPropertyType["DATE"] = "date";
  DatasetPropertyType["DATE_RANGE"] = "dateRange";
  DatasetPropertyType["DATETIME"] = "datetime";
  DatasetPropertyType["NUMERIC"] = "numeric";
  DatasetPropertyType["PROJECT"] = "project";
  DatasetPropertyType["RECORD"] = "record";
  DatasetPropertyType["TEXT"] = "text";
  DatasetPropertyType["TIME"] = "time";
  DatasetPropertyType["USER"] = "user";
  DatasetPropertyType["UUID"] = "uuid";
})(DatasetPropertyType || (exports.DatasetPropertyType = DatasetPropertyType = {}));

var datasetPropertyLabels = (_datasetPropertyLabel = {}, _defineProperty(_datasetPropertyLabel, DatasetPropertyType.BOOLEAN, 'boolean'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.DATE, 'date'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.DATE_RANGE, 'date range'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.DATETIME, 'date and time'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.NUMERIC, 'number'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.PROJECT, 'site'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.RECORD, 'data source record'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.TEXT, 'text'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.TIME, 'time'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.USER, 'user'), _defineProperty(_datasetPropertyLabel, DatasetPropertyType.UUID, 'id'), _datasetPropertyLabel);
exports.datasetPropertyLabels = datasetPropertyLabels;